export class Paginable<T> {
	items: T[] = [];
	totalCount = 0;

	currentPage = 1;
	size = 20;

	constructor(init?: Partial<Paginable<T>>) {
		Object.assign(this, init);
	}

	get totalPages(): number {
		return Math.ceil(this.totalCount / this.size);
	}

	pageCursorCalculator(pageIndex: number, pageSize: number): string {
		return btoa((pageSize * pageIndex - 1).toString());
	}

	buildQuery(targetPage: number) {
		const safePage = Math.max(targetPage, 1);
		const pageIndex = safePage - 1;

		// prima pagina: nessun cursor
		if (pageIndex === 0) {
			return {
				first: this.size
			};
		}

		// tutte le altre pagine: cursor derivato da pageIndex
		return {
			first: this.size,
			after: this.pageCursorCalculator(pageIndex, this.size)
		};
	}
}
